import { render } from "./HelloSection.vue?vue&type=template&id=3fd5819a&scoped=true"
import script from "./HelloSection.vue?vue&type=script&lang=js"
export * from "./HelloSection.vue?vue&type=script&lang=js"

import "./HelloSection.vue?vue&type=style&index=0&id=3fd5819a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3fd5819a"]])

export default __exports__